import { v4 as uuidv4 } from 'uuid';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

export const useChatbot = () => {
    //I will use this to provide labels for when the conversation was stored
    const labelTimestamp = (timestamp) => {
      const now = new Date(); // Current local time
      const conversationDate = new Date(timestamp); // Convert from UTC

      // Get today, yesterday, last week, last month in UTC
      const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      const yesterday = new Date(today);
      yesterday.setUTCDate(today.getUTCDate() - 1);
      const lastWeek = new Date(today);
      lastWeek.setUTCDate(today.getUTCDate() - 7);
      const lastMonth = new Date(today);
      lastMonth.setUTCMonth(today.getUTCMonth() - 1);

      if (conversationDate >= today) return "Today";
      if (conversationDate >= yesterday) return "Yesterday";
      if (conversationDate >= lastWeek) return "Past Week";
      if (conversationDate >= lastMonth) return "Past Month";
      return "Older";
    };
    const getConvoList = async (uname) => {
        try {
            const response = await fetch(`${API_BASE_URL}/chatbot/conversation-list`, {
                method: 'POST',
                credentials: 'include', // Ensures cookies are sent with the request
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ uname }) // Send username and conversation ID
            });
      
            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
      
            const data = await response.json();
            return data.map(({ key, label, timestamp }) => ({
              key,
              label,
              timestamp,
              group: labelTimestamp(timestamp),
            }));
        } catch (error) {
            console.error('Error fetching conversation:', error);
            return [];
        }
      };
      const getConvo = async (uname, cid) => {
        try {
          //console.log(cid);
          const response = await fetch(`${API_BASE_URL}/chatbot/conversation-get`, {
            method: 'POST',
            credentials: 'include', // Required to send cookies
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname, cid })
          });
          if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
          }
          const inputList = await response.json();
          const outputList = inputList.map((item, index) => ({
              id: `msg_${index}`,
              message: item[0], // Take the first element (message)
              status: index % 2 === 0 ? "local" : "success" // Assign "local" for even, "success" for odd
          }));
          return outputList;
        } catch (error) {
          console.error("Error getting conversations");
          return [];
        }
        
      }
    
      const storeConvo = async (uid, cid, message) => {
        try {
          //if its a new conversaion, auto-generate the cid using uuidv4
          let newCid = cid || uuidv4();
          const timestamp = Date.now() / 1000; // Use decimal seconds for millisecond precision
          const response = await fetch(`${API_BASE_URL}/chatbot/conversation-store`, {
            method: 'POST',
            credentials: 'include', // Required to send cookies
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid, cid : newCid, content : message, timestamp })
          });
          if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
          }
          return newCid;
    
        } catch (error){
          console.error('Error storing conversation: ', message);
          return null;
        }
      }
      return {
        getConvoList,
        getConvo,
        storeConvo
      }
}